<div id="billingInformationContainer">
  <div style="display: flex; align-items: start; gap: 10px">
    <h2>Billing</h2>
    <app-button-input
      [icon]="'Edit'"
      [title]="'Edit this section'"
      [hidden]="this.mode == FormMode.Edit"
      (click)="btnEdit_click()"
    ></app-button-input>
  </div>

  <div style="display: flex; align-items: start; gap: 40px">
    <div style="flex: 1">
      <div>
        <app-text-input
          [label]="'Account Number'"
          [required]="true"
          [(ngModel)]="this.data.billingAccountNum"
          [readonly]="this.mode == FormMode.View"
        ></app-text-input>
      </div>
      <div>
        <app-text-input
          [label]="'Routing Number'"
          [required]="true"
          [(ngModel)]="this.data.billingRoutingNum"
          [readonly]="this.mode == FormMode.View"
        ></app-text-input>
      </div>
      <div>
        <app-ddl-input
          [label]="'Account Holder Type'"
          [required]="true"
          [(ngModel)]="this.data.billingAccountHolderType"
          [options]="accountHolderOptions"
          [readonly]="this.mode == FormMode.View"
        ></app-ddl-input>
      </div>
      <div>
        <app-ddl-input
          [label]="'Account Type'"
          [required]="true"
          [(ngModel)]="this.data.billingAccountType"
          [options]="accountTypeOptions"
          [readonly]="this.mode == FormMode.View"
        ></app-ddl-input>
      </div>
    </div>

    <div style="flex: 1">
      <div>
        @if (this.data.billingAddress) {
          <app-street-address
            #billingAddressInfo
            [enableEditing]="this.enableEditing"
            [readonly]="this.mode == FormMode.View"
            [streetAddress]="this.data.billingAddress"
            [addressLabel]="'Billing address'"
          ></app-street-address>
        }
      </div>
    </div>
  </div>
</div>

@if (this.enableEditing) {
  <div>
    @if (this.mode == FormMode.Edit) {
      <input
        type="button"
        value="save"
        style="width: 200px"
        class="button_primary button_var_2 button_right-spacing"
        (click)="this.btnSaveClick()"
        (keydown.enter)="this.btnSaveClick()"
      />
    }
    @if (this.mode == FormMode.Edit) {
      <input
        type="button"
        value="cancel"
        style="width: 200px"
        class="button_primary button_var_2"
        (click)="this.btnCancelClick()"
        (keydown.escape)="this.btnCancelClick()"
      />
    }
  </div>
}
